import getConfig from 'next/config';

export const translationNamespace = 'common';

export const getRuntimeConfiguration = (key: string): string => getConfig().publicRuntimeConfig[`NEXT_PUBLIC_${key}`] as string;
